export const REQUEST_INQUIRY_LIST = 'REQUEST_INQUIRY_LIST'